import { type QNotifyOptions } from 'quasar';

import { BTN_TERTIARY_SM } from './buttons.constants';
import { ICONS_NAME } from './icons.constants';

export const NOTIFY_PROPS: QNotifyOptions = {
    actions: [
        {
            icon: ICONS_NAME.TIMES_OUTLINE,
            ...BTN_TERTIARY_SM
        }
    ],
    color: 'grey-lighter',
    html: false,
    icon: ICONS_NAME.QUESTION_MARK_CIRCLE_SOLID,
    iconColor: 'primary-darker',
    multiLine: false,
    position: 'bottom-right',
    progress: true,
    textColor: 'primary-darker'
};
